import {createSlice, type PayloadAction} from "@reduxjs/toolkit";

export type SemanticSearchSurfacePhase = "closed" | "halfSheet" | "fullscreen";

export interface ISemanticSearchModalState {
    surfacePhase: SemanticSearchSurfacePhase;
    hasConversation: boolean;
}

const initialState: ISemanticSearchModalState = {
    surfacePhase: "closed",
    hasConversation: false
};

export const semanticSearchModalSlice = createSlice({
    name: "semanticSearchModal",
    initialState,
    reducers: {
        openSemanticSearchHalfSheet: (state) => {
            state.surfacePhase = "halfSheet";
        },
        expandSemanticSearchToFullscreen: (state) => {
            state.surfacePhase = "fullscreen";
        },
        openSemanticSearchModal: (state) => {
            state.surfacePhase = "fullscreen";
        },
        closeSemanticSearchModal: (state) => {
            state.surfacePhase = "closed";
        },
        setSemanticSearchHasConversation: (state, action: PayloadAction<boolean>) => {
            state.hasConversation = action.payload;
        }
    }
});

export const {
    openSemanticSearchHalfSheet,
    expandSemanticSearchToFullscreen,
    openSemanticSearchModal,
    closeSemanticSearchModal,
    setSemanticSearchHasConversation
} = semanticSearchModalSlice.actions;
import {createSlice, type PayloadAction} from "@reduxjs/toolkit";

export type SemanticSearchSurfacePhase = "closed" | "halfSheet" | "fullscreen";

export interface ISemanticSearchModalState {
    surfacePhase: SemanticSearchSurfacePhase;
    hasConversation: boolean;
}

const initialState: ISemanticSearchModalState = {
    surfacePhase: "closed",
    hasConversation: false
};

export const semanticSearchModalSlice = createSlice({
    name: "semanticSearchModal",
    initialState,
    reducers: {
        openSemanticSearchHalfSheet: (state) => {
            state.surfacePhase = "halfSheet";
        },
        expandSemanticSearchToFullscreen: (state) => {
            state.surfacePhase = "fullscreen";
        },
        openSemanticSearchModal: (state) => {
            state.surfacePhase = "fullscreen";
        },
        closeSemanticSearchModal: (state) => {
            state.surfacePhase = "closed";
        },
        setSemanticSearchHasConversation: (state, action: PayloadAction<boolean>) => {
            state.hasConversation = action.payload;
        }
    }
});

export const {
    openSemanticSearchHalfSheet,
    expandSemanticSearchToFullscreen,
    openSemanticSearchModal,
    closeSemanticSearchModal,
    setSemanticSearchHasConversation
} = semanticSearchModalSlice.actions;
